import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import {
  useGetBarcode,
  usePostCreateBarcode,
  usePutBarcodeData,
} from "../../hooks";
import { HubHookFormWrapper, PageContent } from "../../components";

import BarcodeBuilderPageContent from "../BarcodeBuilder/BarcodeBuilderPageContent";
import { barcodeMapper, getBarcodeDefaults } from "../BarcodeBuilder/helper";

import { getDataObject } from "../../constants/barcodes";

export const BarcodeBatchEditor = ({ batch }) => {
  const { id } = useParams();
  const passId = !!Number(id);

  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const dataId = searchParams.get("id");

  const { data: serializationData, isLoading: isSerializationLoading } =
    getDataObject(type, dataId);

  const { data, isLoading: isGetLoading } = useGetBarcode(passId && id);
  const { mutate: putBarcode, isLoading: isPutLoading } = usePutBarcodeData();
  const isLoading = isGetLoading || isPutLoading;

  const onSubmit = (formData) => {
    const payload = barcodeMapper(formData, type);
    console.log(payload);
    // putBarcode({ id, ...payload });
  };

  const defaultValues = getBarcodeDefaults(data, serializationData);

  return (
    <PageContent
      disablePadding
      isLoading={isGetLoading || isSerializationLoading}
    >
      <HubHookFormWrapper
        onSubmit={onSubmit}
        sx={{ height: "100%" }}
        defaultValues={defaultValues}
      >
        <BarcodeBuilderPageContent
          disabled={isLoading}
          serializationData={serializationData}
          batch={batch}
        />
      </HubHookFormWrapper>
    </PageContent>
  );
};

export default BarcodeBatchEditor;
